import AdsManager, { InitManagerParams } from './AdsManager';
import { configureForDevelopment } from './placement/local';
/////////////////
import { getGrowthbookGroupVideo } from './abtest/growthbook';
/////////
import adSettings from './config/adsettings';
import { enableDMVerticals, getAdScheduleId, getAdTag } from './config/adschedule';
import ppid from './config/ppid';
import getConsent, { getConsentState } from './consent/consent';
import { checkTopAdsLoaded, clearGptSlots } from './googletag/googletag';
import amaLog, { amaAlert, amaWarn, isDebugTs } from './helpers/log';
import { timeFor } from './helpers/time';
import { collector } from './adstats/collector';
////////////////////
//////////////////////////////////////////////////////////
/////////
import waitFor from './helpers/waitfor';
import {
  initAdResources,
  tcfApiLoaded,
  handleDemandManager,
  isAnyPlacementsLoaded,
  handleGpt,
  loadConsoleScript,
} from './resource/resource';
import { isVideoPage } from './config/domain';
import { isMainAndCategoryPage } from './helpers/utils';
import { getModules } from './modules/index';
import { getHostName } from './config/domain';
import { parseAdsConfig } from './config/platform';
import {
  AD_PLACEMENT_ATTRIBUTE,
  AD_LOADED_ATTRIBUTE,
  setAdLoadedForElement,
  resolveTarget,
} from './placement/placement';
import { isArticle } from './config/device';
////////////////////////
///////////////////////////////////////////
/////////
/////////////////
///////////////////////////////////////////////
/////////
import { perfEventCollector } from './adstats/perfEvent';

// Mark bundle eval start time at module load
perfEventCollector.markBundleEvalStart();
////////////////////
///////////////////////////////////////
/////////

amaLog(`Start running adsBundle ${timeFor('runBundle')}`);

let accConfig: IAdsConfig | undefined;
let pageHasBeenInitialized = false;
let pageInitStarted = false;
let hasConsent: boolean;
let hasActiveConsentInteraction = false;
let usePrebid: boolean;
let pageReset = true;
let responsivesCounter = 0;

let placementNameCounter: { [key: string]: number } = {};

// get attribute ads-conf from current script
const adsPlatformConfJson =
  (document.getElementById('ads-manager') || document.querySelector('script[data-ads-conf]'))?.getAttribute(
    'data-ads-conf',
  ) || undefined;

const parsedConfig = parseAdsConfig(adsPlatformConfJson);
const { loadedByAdsLib } = parsedConfig;

const isAdLoaded = (div: HTMLElement) => !!div && div.hasAttribute(AD_LOADED_ATTRIBUTE);

const getNoOfArticlesWithAds = () => {
  const foundPlacements = document.querySelectorAll(`div[${AD_PLACEMENT_ATTRIBUTE}$='intext_ad_1']`);
  return foundPlacements?.length ?? 0;
};

const tcfReady = tcfApiLoaded().catch((err) => {
  amaWarn('TCF API failed to load or initialize', err);
});

const initPage = async (dfpSection?: string) => {
  // ### 1 Handle multiple call to initPage() ###
  if (pageHasBeenInitialized) return;

  if (pageInitStarted) {
    // Wait for page to be initialized
    await waitFor(() => pageHasBeenInitialized, {
      timeout: 20000,
      errorMessage: `Timeout: Ad waited for config and consent`,
    });
    return;
  }
  pageInitStarted = true;
//////////////////////
////////////////////////
///////////

  amaLog('initPage()');

  // ### 2 Load ad modules, adSettings and accAdConfig ###
  const { useStats, useLimitedAds } = getModules();

  adSettings.refresh();

  amaLog('Get page data ', getHostName(), adSettings.device, { ...adSettings });

  // ### 3 Load dependencies: prebid, gpt,  tcfapi, consent ###

  const { useLoadResourcesBeforeConsent } = getModules();

  let dmReady: Promise<void> | undefined;
  let gptReady: Promise<void> | undefined;
  let consoleScriptReady: Promise<void> | undefined;

  await tcfReady;

  const consentStateReady = getConsentState
    ? getConsentState()
    : getConsent().then((consent) => ({
        hasConsent: consent,
        hasActiveInteraction: false,
      }));

  const usePoliticalAds = accConfig?.enablePoliticalAd === 'true';

  if (useLoadResourcesBeforeConsent) {
    // Load GPT and DemandManager in parallel before consent is given
    dmReady = handleDemandManager(accConfig?.demandManagerUrl).catch(() => {
      amaWarn('Demand Manager failed to load or initialize');
    });
    gptReady = handleGpt(loadedByAdsLib).catch(() => {
      amaWarn('GPT failed to load or initialize');
    });
  }

  const consentState = await consentStateReady;

  hasConsent = consentState.hasConsent as boolean;
  hasActiveConsentInteraction = consentState.hasActiveInteraction;
  amaLog(`consentState: hasConsent=${hasConsent}, hasActiveInteraction=${hasActiveConsentInteraction}`);

  // ### 4 Load modules: adwatch, limitedAds, prebid ###
  useStats && collector.start({ useStatsCollector: accConfig?.statscollector, hasConsent });

  if (!hasConsent && useLimitedAds) {
    amaLog(`useLimitedAds`);
    window.ama.adsUseDemandManager = 'false';
  }
  usePrebid = hasConsent && window.ama?.adsUseDemandManager === 'true';
  const { adsConsoleScript } = getModules();

  if (useLoadResourcesBeforeConsent) {
    await gptReady;
    if (usePrebid) {
      await dmReady;
    }
  } else {
    await handleGpt(loadedByAdsLib).catch(() => {
      amaWarn('GPT failed to load or initialize');
    });
    if (usePrebid) {
      await handleDemandManager(accConfig?.demandManagerUrl).catch(() => {
        amaWarn('Demand Manager failed to load or initialize');
      });
    }

    if (adsConsoleScript) {
      consoleScriptReady = loadConsoleScript(adsConsoleScript).catch(() => {
        amaWarn('Ads Console script failed to load or initialize');
      });
    }
  }
  // Here we have loded GPT and DemandManager (if usePrebid)

  if (usePrebid) {
    enableDMVerticals(accConfig?.verticals);
  }

  const adsInitParams: InitManagerParams = {
    dfpSection: dfpSection,
    hasConsent,
    adsConfig: accConfig,
    _ppId: ppid.get(),
    videoOnly: isVideoPage(),
    usePrebid: usePrebid,
    pageReset: pageReset,
  };
  pageReset = false;

  AdsManager.initConfig(adsInitParams);

///////////////////
///////////////////////////////////////
/////////////////////////////
///////////

  const { useRefreshAdOnBFCache } = getModules();
  useRefreshAdOnBFCache && initRefreshOnBFCachedPage();

  pageHasBeenInitialized = true;

  // Arm perf event emission; actual push is deferred until first slot request.
  // Perf stats are sampled at 100% independently from request stats samplerate.
  perfEventCollector.setEmitWhenFirstSlotRequested(!hasActiveConsentInteraction);
//////////////////////
///////////////////////////////////////////////////////////////////////////////
///////////
};

const initializeAd = async (divId: string, options: InitOptions = {}): Promise<void> => {
  amaLog('initializeAd()', divId, options, timeFor('initializeAd'));

  try {
    let { dfpSection, isSecondArticle, pageNo, div, verticals } = options;

    const { useSecondArticle } = getModules();

    await initPage(dfpSection);

    useSecondArticle &&
      amaLog(`secondarticle for ${divId} isArticle()${isArticle()} noOfArticlesWithAds :${getNoOfArticlesWithAds()}`);

    if (useSecondArticle && isArticle() && pageNo === 2 && getNoOfArticlesWithAds() > 1) {
      amaLog(`observer isSecondArticle with ads: true`);
      isSecondArticle = true;
    }

    const adsInitParams: InitManagerParams = {
      dfpSection: dfpSection,
      hasConsent,
      isSecondArticle,
      pageNo,
      divId,
      pageReset: pageReset,
      div,
      verticals,
    };
    pageReset = false;

    AdsManager.initAd(adsInitParams);

    pageNo === 1 && divId.includes('top_ad') && checkTopAdsLoaded(divId);
  } catch (error) {
    console.error('Error initializing Ad ', error);
  }
};

const notLoadedAdPlacementSelector = `div[${AD_PLACEMENT_ATTRIBUTE}]:not([${AD_LOADED_ATTRIBUTE}])`;

const isResponsiveAd = (placement: string) => placement.startsWith('responsive_');

const handleFoundPlacement = async (
  div: HTMLElement,
  verticals?: string | string[],
  countedPageNo?: number,
): Promise<void> => {
  // ToDo: set div-id for placements if they are missing
  amaLog('handleFoundPlacement ', div.id);

  if (isAdLoaded(div)) {
    amaLog(` handleFoundPlacements ${div.id} already loaded. Skipping ...`);
    return;
  }
  // Update Ad loaded attribute
  setAdLoadedForElement(div);

  // Count suffix for placement
  const attributePlacement = div.getAttribute(AD_PLACEMENT_ATTRIBUTE);

  // Set/Update div placement attribute
  const placement = resolveTarget(attributePlacement, accConfig, div) || attributePlacement;
  if (!placement) {
    amaWarn(`handleFoundPlacement - placement ${attributePlacement} not found in config for `, div);
    return;
  }

  let newPlacement = placement;

  // On main/category modify responsive placements to be 1-8, x,x,x ...
  if (isMainAndCategoryPage() && isResponsiveAd(newPlacement)) {
    responsivesCounter += 1;
    const placementNo = responsivesCounter > 8 ? 'x' : `${responsivesCounter}`;
    newPlacement = `responsive_${placementNo}`;
    newPlacement !== placement && div.setAttribute(AD_PLACEMENT_ATTRIBUTE, newPlacement);
  }

  placementNameCounter[newPlacement] = placementNameCounter[newPlacement] ? placementNameCounter[newPlacement] + 1 : 1;

  let pageNo = countedPageNo ?? 1;
  if (!countedPageNo && !newPlacement.startsWith('top_ad')) {
    pageNo = Math.max(placementNameCounter['intext_ad_1'] ?? 1, placementNameCounter['responsive_1'] ?? 1);
  }

  // Set/Update div id and placement in sequence to be unique
  const { useSkipPageNoSuffix } = getModules();
  const isRepeatedPlacement = placementNameCounter[newPlacement] > 1;
  const placementId =
    useSkipPageNoSuffix && !isRepeatedPlacement
      ? newPlacement
      : `${newPlacement}-${placementNameCounter[newPlacement]}`;
  div.id = placementId;

  amaLog(
    `handleFoundPlacement placement:${newPlacement} count:${placementNameCounter[newPlacement]} div.id:${div.id} pageNo:${pageNo}`,
  );

  await initializeAd(placementId, { pageNo: pageNo, div: div, verticals });
};

const placementObserver = new MutationObserver(async (mutationsList: MutationRecord[]) => {
  for (const mutation of mutationsList) {
    if (mutation.type !== 'childList') continue;

    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue; // Element nodes only

      const element = node as HTMLElement;

      if (element.matches(notLoadedAdPlacementSelector)) {
        await handleFoundPlacement(element);
      }

      const nested = element.querySelectorAll(notLoadedAdPlacementSelector);
      for (const child of nested) {
        await handleFoundPlacement(child as HTMLElement);
      }
    }
  }
});

const handlePlacementsInContent = (content?: HTMLElement, verticals?: string | string[], pageNo?: number) => {
  // Scan for placements that are not marked handled (ad-loaded)
  const placementsToLoad = (content || document).querySelectorAll<HTMLElement>(notLoadedAdPlacementSelector);

  handleFoundPlacements(Array.from(placementsToLoad), verticals, pageNo);
};

const handleFoundPlacements = async (
  placementsToLoad: HTMLElement[],
  verticals?: string | string[],
  pageNo?: number,
) => {
  if (placementsToLoad && placementsToLoad.length > 0) {
    amaLog(
      `PlacementManager - Found ${placementsToLoad.length} (${timeFor(
        'handlePlacementsInContent',
      )}) placements to handle`,
      placementsToLoad,
    );

    for (let i = 0; i < placementsToLoad.length; i++) {
      await handleFoundPlacement(placementsToLoad[i], verticals, pageNo);
    }
  }
};

const resetInitLoad = () => {
  amaLog('resetInitLoad');

  resetPlacements();

  const { useStats, useContentUpdatedEvent } = getModules();
  if (!useContentUpdatedEvent) {
    placementObserver.disconnect();
    placementObserver.observe(document.body, { childList: true, subtree: true });
  }
  useStats && collector.start({ useStatsCollector: accConfig?.statscollector, reset: true, hasConsent });
};

const resetPlacements = () => {
  amaLog('resetPlacements');

  clearGptSlots();
  placementNameCounter = {};
  responsivesCounter = 0;
  pageReset = true;

  unsetPlacementLoadedAttribute();
};

const unsetPlacementLoadedAttribute = () => {
  // Remove loaded attribute to trigger re-initialization of placements, exclude top_ad
  const placements = document.querySelectorAll<HTMLElement>(
    `div[${AD_PLACEMENT_ATTRIBUTE}]:not([${AD_PLACEMENT_ATTRIBUTE}="top_ad"])`,
  );
  amaLog(`unsetPlacementLoadedAttribute - Found ${placements.length} placements to reset`);
  placements?.forEach((div) => div.removeAttribute(AD_LOADED_ATTRIBUTE));
};

const initRefreshOnBFCachedPage = () => {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      amaLog('Navigating to cached page - Refreshing display ads');
      resetPlacements();
      handlePlacementsInContent();
    }
  });
  const [nav] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  if (nav?.transferSize === 0) {
    amaLog('Page loaded from cache!');
  }
};

const initHandleInjectedContent = async () => {
  amaLog(`Init handling injected content ...`, timeFor('initInjectedContentHandling'));
  window.ama.handleContent = (content, options) => {
    amaLog(`window.ama.handleContent ...`, timeFor('handleContent'), content, options);
    const { pageNo, pageData } = options ?? {};
    handlePlacementsInContent(content, pageData?.verticals, pageNo);
  };
};

const initPlacementHandling = async () => {
  amaLog(`initPlacementHandling ...`, timeFor('initPlacementHandling'));

  const { usePlacementCheck } = getModules();

  if (usePlacementCheck) {
    if (!isAnyPlacementsLoaded() && !isVideoPage()) {
      amaLog(`initPlacementHandling: - Wait for Placement Wrapper to be loaded ...`);
      await waitFor(isAnyPlacementsLoaded, {
        timeout: 5000,
        errorMessage: `Timeout: Placementwrappers are missing `,
      });
    }
    amaLog('initPlacementHandling: Placement Wrapper is loaded', timeFor('initPlacementHandling'));
  }
/////////////////
//////////////////////////////////
///////////

  handlePlacementsInContent();
  if (isVideoPage()) {
    amaLog(`initPlacementHandling isVideoPage - initPage only ... `);
    await initPage();
  }
};

let adsHidden = false;
////////////////////////
////////////////////////////////////
/////////////////
////////////
///////////////////
 
/////////

amaLog('adsPlatformConfJson', parsedConfig);

perfEventCollector.markAccConfigStart();
////////////////////
//////////////////////////////////////
/////////
!adsHidden &&
  initAdResources(parsedConfig)
  .then((config) => {
    perfEventCollector.markAccConfigEnd();
////////////////////////
////////////////////////////////////////
/////////////
    amaLog('AdResources loaded');

    accConfig = config;

    if (!accConfig || !(accConfig?.ads && accConfig.ads.length > 0)) {
      amaAlert('No valid ad config found');
      return;
    }

    const { useSecondArticle, useContentUpdatedEvent } = getModules();
    if (window.ama) {
      window.ama.init = async (uniqueId?: string | number, options?: InitOptions): Promise<void> => {
        amaLog('window.ama.init called initializeAds ...', options);

        if (options?.dfpSection === 'general') {
          // Remove posibility to override to a general section
          // ToDo: Remove when response from ads-microservice no longer has dfpSection
          options = { ...options, dfpSection: undefined };
        }
        amaLog('options', options);

        if (useSecondArticle && isArticle()) {
          const { isSecondArticle } = options || {};

          window.ama.isSecondArticle = !!isSecondArticle;
          amaLog('observer - isSecondArticle', window.ama.isSecondArticle);
        }
      };
      amaLog('window.ama.init available');

      window.ama.clearSlots = (): void => {
        resetInitLoad();
      };
      amaLog('window.ama.clearSlots available');
    }
    adSettings.init();

    // Mark bundle eval end after all core modules are imported
    perfEventCollector.markBundleEvalEnd();
////////////////////////
/////////////////////////////////////////
/////////////

    initPage();

    if (useContentUpdatedEvent) {
      initHandleInjectedContent();
      handlePlacementsInContent();
    } else {
      amaLog('Init Observer for handling placements');

      placementObserver.observe(document.body as HTMLElement, { childList: true, subtree: true });
      initPlacementHandling();
    }

    if (window.ama) {
      window.amav = {
        getAdScheduleId,
/////////////////////////
        getVideoExperimentGroup: getGrowthbookGroupVideo,
/////////////////
        getVideoPpId: ppid.get,
        // window.amav.getAdTag({ gamAdTag?: string; startType?: 'autoPlay' | 'clickToPlay'; isSecondArticle?: boolean; })
        getAdTag: (...videoConfig) => getAdTag(accConfig, ...videoConfig),
      };
      amaLog('window.ama.video available');
    }
  })
  .catch((error) => {
    console.error('AdResources fail to load', error);
  });
